const Main = r => require.ensure([], () => r(require('@/components/Main')), 'Main')

// 主页
const Home = r => require.ensure([], () => r(require('@/components/home/Home')), 'Main')

// 资讯中心
const Information = r => require.ensure([], () => r(require('@/components/information/Information')), 'Main')
// 资讯中心详情
const InformationDetail = r => require.ensure([], () => r(require('@/components/information/InformationDetail')), 'Main')

// 电子保函
const InsuranceGuarantee = r => require.ensure([], () => r(require('@/components/insuranceGuarantee/InsuranceGuarantee')), 'Main')
// 流程
const Flow = r => require.ensure([], () => r(require('@/components/insuranceGuarantee/Flow')), 'Main')
// 概念
const Concept = r => require.ensure([], () => r(require('@/components/insuranceGuarantee/Concept')), 'Main')
// 优势
const Advantage = r => require.ensure([], () => r(require('@/components/insuranceGuarantee/Advantage')), 'Main')

// 电子银行保函
const BankGuarantee = r => require.ensure([], () => r(require('@/components/bankGuarantee/BankGuarantee')), 'Main')

// 关于我们 AboutUs
const AboutUs = r => require.ensure([], () => r(require('@/components/aboutUs/AboutUs')), 'Main')
// 公司介绍
const Introduce = r => require.ensure([], () => r(require('@/components/aboutUs/Introduce')), 'Main')
// 发展历程
const Development = r => require.ensure([], () => r(require('@/components/aboutUs/Development')), 'Main')
// 组织架构
const Organization = r => require.ensure([], () => r(require('@/components/aboutUs/Organization')), 'Main')

const Error404 = r => require.ensure([], () => r(require('@/components/Error404')), 'error')


export const mainRouter = [
  {
    path: '/',
    redirect: '/Home',
    component: Main,
    children: [
      {
        path: 'Home',
        component: Home,
        name: 'Home'
      },
      {
        path: 'Information',
        component: Information,
        name: 'Information'
      },
      {
        path: 'InformationDetail',
        component: InformationDetail,
        name: 'InformationDetail'
      },
      {
        path: 'InsuranceGuarantee',
        component: InsuranceGuarantee,
        name: 'InsuranceGuarantee',
        redirect: '/InsuranceGuarantee/Flow',
        children: [
          {
            path: 'Flow',
            component: Flow,
            name: 'Flow'
          },
          {
            path: 'Concept',
            component: Concept,
            name: 'Concept'
          },
          {
            path: 'Advantage',
            component: Advantage,
            name: 'Advantage'
          },
        ]
      },
      {
        path: 'BankGuarantee',
        component: BankGuarantee,
        name: 'BankGuarantee'
      },
      {
        path: 'AboutUs',
        component: AboutUs,
        name: 'AboutUs',
        redirect: '/AboutUs/Introduce',
        children: [
          {
            path: 'Introduce',
            component: Introduce,
            name: 'Introduce'
          },
          {
            path: 'Development',
            component: Development,
            name: 'Development'
          },
          {
            path: 'Organization',
            component: Organization,
            name: 'Organization'
          },
        ]
      },
    ]
  },
]

export const errorRouter = {
  path: '*',
  name: 'Error404',
  component: Error404,
  meta: {
    title: '404页面',
    isHide: true
  }
}

export const routes = [
  ...mainRouter,
  // ...otherRouter,
  errorRouter
]



// WEBPACK FOOTER //
// ./src/router/routes.js